import { Box, Paper, Tooltip, Typography } from '@mui/material';
import { AttachFile, Delete as DeleteIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { useEffect, useState } from 'react';
import LeaseAttachmentsCRU from './leaseAttachmentsCRU';
import { useParams } from 'react-router-dom';
import { DeletePopUp } from '../../../../shared_elements/components';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { getAttachmentsApi } from '../apiServices';
import axios from 'axios';
import { checkApiStatus } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { PageLoader } from '../../../../shared_elements';
import { PermissionWrapper } from '../../../../wrappers';
import { useDispatch, useSelector } from 'react-redux';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import { getStorage } from '../../../../shared_elements/actionCreators';
import { Restore as RestoreIcon } from '@mui/icons-material';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import FilePreview from '../../../../shared_elements/components/FilePreview';

const LeaseAttachments = () => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const [addEditAttachments, setAddEditAttachments] = useState({ modal: false, data: null });
    const [isLoading, setLoading] = useState(false);
    const [deleteAttachment, setDeleteAttachment] = useState({ modal: false, data: null })
    const [attachmentsFile, setAttachmentsFile] = useState([]);
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [filePreviewData, setFilePreviewData] = useState({ modal: false, data: null });


    useEffect(() => {
        getAttachmentsList();
    }, []);
    const getAttachmentsList = (loaderType) => {
        setLoading(true);
        globalGetService(getAttachmentsApi(params.leaseSlug))
            .then(response => {
                setLoading(false);
                setAttachmentsFile(response?.data?.data?.attachments);
            })
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "headline" }))
    }

    const uploadedFileData = getApiResponse("lease", leaseSlug);
    const onDownloadAttachment = async (file_url, fileName) => {
        axios.get(file_url, { responseType: 'arraybuffer', })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click()
            })
            .catch(error => { console.error("Download failed:", error); })
    }
    const onDeleteAttachment = () => {
        setLoading(true)
        globalDeleteService(`delete-attachment/${deleteAttachment?.data?.slug}?section_type=headlines-attachments`).then(response => {
            if (checkApiStatus(response)) {
                setLoading(false)
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                setDeleteAttachment({ modal: false, data: null });
                getAttachmentsList();
            } else {
                setLoading(false)
                enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            }

        })
    }

    const handleUpload = async () => {
        setLoading(true);
        setTimeout(() => { setLoading(false) }, 1500);
        setSlug({ slug: params?.leaseSlug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "lease",
            slug: params?.leaseSlug,
            query: { section_type: 'headlines-attachments', record_action_type: 'updated' },
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
                trackActivity('Item Added', { page_title: `Headlines Add Attachments`, success_msg: success_msg, item_slug: leaseSlug, payload: fileUploadDetails.attachments })
                getAttachmentsList();
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
                trackActivity('Item Added', { page_title: `Headlines Add Attachments`, error_msg: err?.message || "Error while uploading files", item_slug: leaseSlug, payload: fileUploadDetails.attachments })
            }
        });
        setSlug({})
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Headlines`, page_type: page_type, })
    }

    return (
        <Paper className='card-container' sx={{ marginTop: '10px', marginRight: '1px', boxShadow: "0px 0px 0px 1px #BBBBBB" }}>
            <Box p={1} sx={{ backgroundColor: '#F8F8F8', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography fontWeight={500} fontSize={16}>Lease Attachments</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Tooltip title="Revision History">
                        <RestoreIcon fontSize="small" className="revision-history" onClick={() => { setRevisionHistory({ modal: true, data: { slug: leaseSlug }, mode: 'view' }); handleItemClicked('Lease Attachments RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} color="primary" />
                    </Tooltip>
                    {(leaseSlug === slug?.slug) && <UploadingIcon viewFileStatus={() => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })} />}
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['U'] }}>
                        {
                            <Tooltip title="Add Attachments">
                                <Box sx={{ display: "flex", gap: '2px', justifyContent: "flex-start", alignItems: 'flex-start' }}>
                                    <AttachFile fontSize="small" color="primary" onClick={() => { setAddEditAttachments({ modal: true, data: attachmentsFile }); handleItemClicked(' Add AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                    <Box sx={{ position: "relative", bottom: 8, right: '3px', fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap', }} >
                                        ({attachmentsFile?.length})
                                    </Box>
                                </Box>
                            </Tooltip>
                        }
                    </PermissionWrapper>
                </Box>
            </Box>
            <Box>
                <Box className='headlines-box-style' sx={{ maxHeight: '169px' }}>
                    {attachmentsFile?.length ?
                        <>
                            {attachmentsFile.map((item, index) => {
                                return (
                                    <div style={{ paddingLeft: "5px" }} >
                                        {(() => {
                                            return (
                                                <>
                                                    <ul style={{ cursor: 'pointer', display: 'flex', gap: '2px', justifyContent: 'flex-start' }} className="list-inline">
                                                        <li>
                                                            <a onClick={() => { onDownloadAttachment(item?.download_url, item?.file_name); handleItemClicked('Download AttachmentIcon') }} download={item?.file_name}>
                                                                <Tooltip title="Download">  <VerticalAlignBottomIcon fontSize="small" color='primary' /></Tooltip>
                                                            </a>
                                                        </li>
                                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['D'] }}>
                                                            <li>
                                                                <Tooltip title="Delete"> <DeleteIcon fontSize='small' color='error' onClick={() => { setDeleteAttachment({ modal: true, data: item }); handleItemClicked('Delete AttachmentIcon') }} /></Tooltip>
                                                            </li>
                                                        </PermissionWrapper>
                                                        {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['U'] }}> */}
                                                        <li className="list-inline-item">
                                                            <Tooltip title="View" arrow> <VisibilityIcon color="primary" onClick={() => { setFilePreviewData({ modal: true, data: item }); handleItemClicked('View AttachmentIcon') }} fontSize='small' /></Tooltip>
                                                        </li>
                                                        {/* </PermissionWrapper> */}
                                                        <li style={{ paddingLeft: '5px' }}>
                                                            <span style={{ verticalAlign: 'super', fontSize: '14px', lineBreak: 'anywhere' }}>{item?.file_name}</span>
                                                        </li>
                                                    </ul>
                                                </>
                                            )
                                        })()}

                                    </div>
                                )
                            }
                            )}
                        </> :
                        <Typography sx={{ textAlign: "center", fontSize: 14, fontWeight: 500, }}> No Attachment Available </Typography>
                    }
                </Box>

            </Box>
            {
                addEditAttachments.modal ? <LeaseAttachmentsCRU
                    fileUpload={handleUpload}
                    params={params}
                    addEditAttachments={addEditAttachments}
                    onToggleModal={() => setAddEditAttachments({ modal: false, data: null })}
                    getResponseBack={() => getAttachmentsList()}
                /> : null
            }
            {
                deleteAttachment.modal ? <DeletePopUp
                    modal={deleteAttachment.modal}
                    title='Delete Attachment'
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteAttachment({ modal: false, data: null })}
                    onDeleteRecords={onDeleteAttachment}
                /> : null
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />
            {revisionHistory?.modal ?
                <RevisionHistory
                    moduleName={"lease"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                    section_type='headlines-attachments'
                /> : null
            }
            {filePreviewData?.modal ?
                <FilePreview
                    filePreview={filePreviewData}
                    onToggleModal={() => setFilePreviewData({ modal: false, data: null })}
                /> : null}
            {isLoading ? <PageLoader /> : null}
        </Paper>
    )
}

export default LeaseAttachments;